export default __webpack_public_path__ + "static/media/coin-full.419935c8.png";